<goab-callout type="information" [heading]="title" *ngIf="!messageDialog" data-cy="title">
  <div mat-dialog-content [innerHTML]="description" data-cy="content"></div>
  <div mat-dialog-actions>
    <div></div>
    <goab-button size="compact" mat-dialog-close class="goab-button compact" data-cy="ok-button"> Okay </goab-button>
  </div>
</goab-callout>
<ng-container *ngIf="messageDialog">
  <h3 mat-dialog-title data-cy="title">{{ title }}</h3>
  <div mat-dialog-content data-cy="description" [innerHTML]="description"></div>

  <div mat-dialog-actions>
    <div></div>
    <goab-button mat-dialog-close class="goab-button" data-cy="ok-button">Okay</goab-button>
  </div>
</ng-container>
